import { PieChart, Pie, Cell } from "recharts";

const RADIAN = Math.PI / 180;
const needle = (
  value: number,
  data: any,
  cx: any,
  cy: any,
  iR: any,
  oR: any,
  color: any
) => {
  let total = 0;
  data.forEach((v: any) => {
    total += v.value;
  });
  const ang = total === 0 ? 0 : 180 * (1 - value / total);
  const length = (iR + 2 * oR) / 3;
  const sin = Math.sin(-RADIAN * ang);
  const cos = Math.cos(-RADIAN * ang);
  const r = 5;
  const x0 = cx + 5;
  const y0 = cy + 5;
  const xba = x0 + r * sin;
  const yba = y0 - r * cos;
  const xbb = x0 - r * sin;
  const ybb = y0 + r * cos;
  const xp = x0 + length * cos;
  const yp = y0 + length * sin;

  return [
    <circle key="circle" cx={x0} cy={y0} r={r} fill={color} stroke="none" />,
    <path
      key="path"
      d={`M${xba} ${yba}L${xbb} ${ybb} L${xp} ${yp} L${xba} ${yba}`}
      stroke="#none"
      fill={color}
    />,
  ];
};

export function Gauge(props: {
  data: { name: string; value: number; color: string }[];
  value: number;
  width: number;
}) {
  const cx = Math.floor(props.width / 2);
  const cy = Math.floor(props.width / 3);
  const iR = cy * 0.8;
  const oR = cy;
  return (
    <PieChart width={props.width} height={Math.ceil(props.width / 3 + 16)}>
      <Pie
        dataKey="value"
        startAngle={180}
        endAngle={0}
        data={props.data}
        cx={cx}
        cy={cy}
        innerRadius={iR}
        outerRadius={oR}
        stroke="none"
        animationBegin={0}
        animationDuration={0}
      >
        {props.data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.color} />
        ))}
      </Pie>
      {needle(props.value, props.data, cx, cy, iR, oR, "#777")}
    </PieChart>
  );
}
